import React from 'react';
import { ethers } from 'ethers';
import Box from './Box';
import Flex from './Flex';

function formatDigits(parts: string[], digits: number) {
  const afterDecimal = parts[1].slice(0, digits);
  const padding = afterDecimal.length === 1 ? '00'
    : afterDecimal.length === 2 ? '0' : ''; 
  
  return `${parts[0]}.${afterDecimal}${padding}`;
}

function toDigits(string: string, digits: number) {
  const parts = string.split('.');

  if (parts.length === 2) {
    return formatDigits(parts, digits);
  } else {
    // const priceBN = BigNumber.from(string);
    const ethPrice = ethers.utils.formatEther(string);
    const ethParts = ethPrice.toString().split('.');
    return formatDigits(ethParts, digits);
  }
}

const EthSign = ({ value, color = 'copy', ...rest }: any) => {
  return (
    <Flex color={color} alignCenter>
      <Box color={color} mr="2px" {...rest}>
        Ξ{' '}
      </Box>
      {value && toDigits(value, 3)}
    </Flex>
  );
};

export default EthSign;
